/*
 * @Copyright (c): Knowdee All rights reserved.
 * @Description: Type your file description
 * @Author: Type your email address
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2023-08-19 16:48:13
 * @LastEditTime: 2023-08-30 16:25:50
 * @FilePath: /client-h5-v2/src/store/modules/radio.ts
 */

export const radio = {
  namespaced: true, // 防止模块命名冲突 设置后调用mutations和action需要'模块名/方法' 例如  app/setMenuList
  state: {
    playStatus: false,
    textPlayStatus: true, // 文本模版里的流逝数据，或者llm模版中的流式数据是否完成或者停止播放，true已完成，false未完成
    radioCommand: ''
  },
  getters: {
    playStatus: (state: any) => state.playStatus,
    textPlayStatus: (state: any) => state.textPlayStatus,
    radioCommand: (state: any) => state.radioCommand
  },
  mutations: {
    SET_PLAY_STATUS (state: { playStatus: boolean }, playStatus: boolean) {
      state.playStatus = playStatus
    },
    SET_TEXT_PLAY_STATUS (state: { textPlayStatus: boolean }, textPlayStatus: boolean) {
      state.textPlayStatus = textPlayStatus
    },
    SET_RADIO_COMMAND (state: { radioCommand: string }, radioCommand: string) {
      state.radioCommand = radioCommand
    }
  },
  actions: {
  }
}

